import { render, staticRenderFns } from "./CartCardPositions.vue?vue&type=template&id=94adc04c&scoped=true"
import script from "./CartCardPositions.vue?vue&type=script&lang=ts"
export * from "./CartCardPositions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94adc04c",
  null
  
)

export default component.exports